"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userQuerySchema = exports.userListSchema = exports.getMeUserSchema = exports.userSchemaBase = exports.profileSectionsSchema = exports.lichessRatingsSchema = exports.lichessPerfSchema = void 0;
const zod_1 = require("zod");
const countries_1 = require("./countries");
const onboarding_1 = require("./onboarding");
exports.lichessPerfSchema = zod_1.z.object({
    rating: zod_1.z.number().int(),
    games: zod_1.z.number().int().optional(),
    rd: zod_1.z.number().int().optional(),
    prog: zod_1.z.number().int().optional(),
    prov: zod_1.z.boolean().optional(),
    rank: zod_1.z.number().int().optional(),
});
exports.lichessRatingsSchema = zod_1.z.record(zod_1.z.string(), exports.lichessPerfSchema);
exports.profileSectionsSchema = zod_1.z.array(zod_1.z.object({
    title: zod_1.z.string(),
    content: zod_1.z.string(),
}));
exports.userSchemaBase = zod_1.z.object({
    id: zod_1.z.number().int().positive(),
    email: zod_1.z.string(),
    username: zod_1.z.string(),
    name: zod_1.z.string().nullish(),
    lastname: zod_1.z.string().nullish(),
    isMaster: zod_1.z.boolean().default(false),
    isPrivate: zod_1.z.boolean().default(false),
    status: zod_1.z.enum(["active", "disabled"]).default("active"),
    title: zod_1.z.string().nullish(),
    rating: zod_1.z.number().int().nullish(),
    bio: zod_1.z.string().nullish(),
    profileSections: exports.profileSectionsSchema.nullish(),
    profilePictureThumbnailUrl: zod_1.z.string().nullish(),
    profilePictureUrl: zod_1.z.string().nullish(),
    chesscomUrl: zod_1.z.string().nullish(),
    lichessUrl: zod_1.z.string().nullish(),
    lichessRatings: exports.lichessRatingsSchema.nullish(),
    schedule: zod_1.z.array(zod_1.z.any()).nullish(),
    hourlyRate: zod_1.z.number().nullish(),
    languages: zod_1.z.array(zod_1.z.string()).nullish(),
    teachingFocuses: zod_1.z.array(zod_1.z.string()).nullish(),
    youtubeVideos: zod_1.z.array(zod_1.z.string()).nullish(),
    phoneNumber: zod_1.z.string().nullish(),
    location: zod_1.z.string().nullish(),
    country: zod_1.z
        .string()
        .nullish()
        .transform((value) => !value || value.trim() === "" ? null : value.trim().toUpperCase())
        .refine((value) => (0, countries_1.isValidCountryCode)(value), {
        message: "Invalid or restricted country",
    }),
    twitchUrl: zod_1.z.string().nullable().optional(),
    youtubeUrl: zod_1.z.string().nullable().optional(),
    instagramUrl: zod_1.z.string().nullable().optional(),
    xUrl: zod_1.z.string().nullable().optional(),
    facebookUrl: zod_1.z.string().nullable().optional(),
    tiktokUrl: zod_1.z.string().nullable().optional(),
    avgReviewRating: zod_1.z.number().nullable().optional(),
    studentsCount: zod_1.z.number().nullable().optional(),
});
exports.getMeUserSchema = exports.userSchemaBase.extend({
    onboardingStatus: zod_1.z
        .nativeEnum(onboarding_1.MasterOnboardingStep)
        .default(onboarding_1.MasterOnboardingStep.BasicInfo),
});
exports.userListSchema = zod_1.z.array(exports.userSchemaBase);
exports.userQuerySchema = zod_1.z.object({
    username: zod_1.z.string().min(1).optional(),
    email: zod_1.z.string().optional(),
    title: zod_1.z.string().min(1).optional(),
    limit: zod_1.z
        .string()
        .regex(/^\d+$/)
        .transform((val) => parseInt(val, 10))
        .optional(),
    isMaster: zod_1.z
        .string()
        .transform((val) => val === "true")
        .optional(),
    minRating: zod_1.z
        .string()
        .regex(/^\d+$/)
        .transform((val) => parseInt(val, 10))
        .optional(),
    maxRating: zod_1.z
        .string()
        .regex(/^\d+$/)
        .transform((val) => parseInt(val, 10))
        .optional(),
});
